module.exports = __webpack_public_path__ + "img/pay.10a1b294.png";